// src/components/TextPage.js
import React from 'react';
import styles from './TextPage.module.css';

function TextPage({ sections }) {
  return (
    <div className={styles.textPage}>
      {sections.map((section, i) => (
        <div className={styles.textSection} key={i}>
          {section.title && <h2>{section.title}</h2>}
          {section.text && <p>{section.text}</p>}
          {section.list && (
            <ul>
              {section.list.map((item, j) => (
                <li key={j}>{item}</li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
}

export default TextPage;
